import { createSlice } from "@reduxjs/toolkit";
import { approveClaimItem } from "../../reducer/claimsApproveItem/claimsApproveItemReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const approveClaimItemSlice = createSlice({
  name: "approveClaimItem",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(approveClaimItem.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(approveClaimItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(approveClaimItem.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default approveClaimItemSlice.reducer;
